export interface AssetTreeFilters {
  branchIds?: string[];
  segmentIds?: string[];
  clientIds?: string[];
  supplierIds?: string[];
  vehicleIds?: string[];
  driverIds?: string[];
  includeNullBranch?: boolean;
  includeNullSegment?: boolean;
  includeNullClient?: boolean;
  includeNullSupplier?: boolean;
  includeNullVehicle?: boolean;
  includeNullDriver?: boolean;
}

export interface AssetTreePayload {
  branchIds: string[];
  segmentIds: string[];
  clientIds: string[];
  supplierIds: string[];
  vehicleIds: string[];
  driverIds: string[];
  includeNullBranch: boolean;
  includeNullSegment: boolean;
  includeNullClient: boolean;
  includeNullSupplier: boolean;
  includeNullVehicle: boolean;
  includeNullDriver: boolean;
}

const sanitizeIds = (values?: string[]): string[] =>
  Array.isArray(values) ? values.filter((value) => value != null && value !== "") : [];

export const buildAssetTreePayload = (filters?: AssetTreeFilters): AssetTreePayload => ({
  branchIds: sanitizeIds(filters?.branchIds),
  segmentIds: sanitizeIds(filters?.segmentIds),
  clientIds: sanitizeIds(filters?.clientIds),
  supplierIds: sanitizeIds(filters?.supplierIds),
  vehicleIds: sanitizeIds(filters?.vehicleIds),
  driverIds: sanitizeIds(filters?.driverIds),
  includeNullBranch: filters?.includeNullBranch ?? false,
  includeNullSegment: filters?.includeNullSegment ?? false,
  includeNullClient: filters?.includeNullClient ?? false,
  includeNullSupplier: filters?.includeNullSupplier ?? false,
  includeNullVehicle: filters?.includeNullVehicle ?? false,
  includeNullDriver: filters?.includeNullDriver ?? false,
});
